export const GetTotalCountCourses = `
	query GetTotalCountCourses($tags: [Int], $traits: [String], $uids: [Int], $page: Int, $perpage: Int, $search: String, $orderby: OrderByEnum) {
		Courses(tags: $tags, page: $page, perpage: $perpage, uids: $uids, traits: $traits, search: $search, orderby: $orderby) {
			totalCount
		}
	}
`;
